const VIEWS = {
    LIVE: {
        state: "LIVE",
        labelEn: "Live",
        labelHi: "लाइव",
        explanationEn: "Proven working in production with recorded evidence.",
        explanationHi: "प्रोडक्शन में सबूत के साथ काम करता हुआ।",
        nextActionEn: "You can use it now.",
        nextActionHi: "आप इसे अभी इस्तेमाल कर सकते हैं।",
        marker: "●",
        tone: "positive",
    },
    APPROVAL_REQUIRED: {
        state: "APPROVAL_REQUIRED",
        labelEn: "Approval needed",
        labelHi: "अनुमति ज़रूरी",
        explanationEn: "It works, but every run asks the owner for approval first.",
        explanationHi: "यह काम करता है, लेकिन हर रन से पहले मालिक की अनुमति माँगता है।",
        nextActionEn: "Approve from the approval queue when asked.",
        nextActionHi: "पूछे जाने पर अप्रूवल कतार से अनुमति दें।",
        marker: "◐",
        tone: "warning",
    },
    PREVIEW: {
        state: "PREVIEW",
        labelEn: "Preview",
        labelHi: "प्रीव्यू",
        explanationEn: "Visible for trying out; not proven in production yet.",
        explanationHi: "आज़माने के लिए दिखता है; प्रोडक्शन में अभी सिद्ध नहीं।",
        nextActionEn: "Try it safely — nothing destructive runs.",
        nextActionHi: "सुरक्षित रूप से आज़माएँ — कोई destructive काम नहीं चलता।",
        marker: "○",
        tone: "neutral",
    },
    DISABLED: {
        state: "DISABLED",
        labelEn: "Off",
        labelHi: "बंद",
        explanationEn: "Turned off by policy; it cannot run right now.",
        explanationHi: "नीति से बंद है; अभी चल नहीं सकता।",
        nextActionEn: "Ask the owner to enable it if you need it.",
        nextActionHi: "ज़रूरत हो तो मालिक से चालू करवाएँ।",
        marker: "◌",
        tone: "neutral",
    },
    OWNER_ACTION_REQUIRED: {
        state: "OWNER_ACTION_REQUIRED",
        labelEn: "Owner action needed",
        labelHi: "मालिक को कार्रवाई करनी है",
        explanationEn: "Blocked until the owner completes a required step.",
        explanationHi: "मालिक का एक ज़रूरी कदम पूरा होने तक अवरुद्ध है।",
        nextActionEn: "Tell the owner what is needed.",
        nextActionHi: "मालिक को बताएँ क्या करना है।",
        marker: "▲",
        tone: "warning",
    },
    NOT_CONFIGURED: {
        state: "NOT_CONFIGURED",
        labelEn: "Not set up",
        labelHi: "सेटअप नहीं हुआ",
        explanationEn: "Required configuration is missing; nothing is broken.",
        explanationHi: "ज़रूरी configuration मौजूद नहीं; कुछ टूटा नहीं है।",
        nextActionEn: "Finish setup in Settings.",
        nextActionHi: "Settings में सेटअप पूरा करें।",
        marker: "△",
        tone: "warning",
    },
    BLOCKED: {
        state: "BLOCKED",
        labelEn: "Blocked",
        labelHi: "अवरुद्ध",
        explanationEn: "A named blocker stops it — see the reason shown.",
        explanationHi: "एक बताई गई समस्या इसे रोकती है — दिखाया कारण देखें।",
        nextActionEn: "Resolve the blocker or ask for help.",
        nextActionHi: "रुकावट दूर करें या मदद माँगें।",
        marker: "■",
        tone: "blocked",
    },
};
/**
 * Legacy `ProductCapabilityStatus` values → canonical runtime states.
 * `AVAILABLE`/`CONFIGURED` are surface-level statements (the settings row
 * exists / a form was configured) — they are NOT production-proven, so they
 * map to PREVIEW, never LIVE. LIVE is reachable only through the canonical
 * CapabilityRuntimeState produced by ProductRuntimeTruth.
 */
const LEGACY_STATUS_MAP = {
    AVAILABLE: "PREVIEW",
    CONFIGURED: "PREVIEW",
    REQUIRES_SETUP: "NOT_CONFIGURED",
    DISABLED_BY_POLICY: "DISABLED",
    FACTORY_PROOF_PENDING: "PREVIEW",
    UNAVAILABLE: "BLOCKED",
};
export function buildCapabilityStateView(state) {
    const normalized = LEGACY_STATUS_MAP[state] ?? state;
    return VIEWS[normalized] ?? VIEWS.NOT_CONFIGURED;
}
export const CAPABILITY_STATE_VIEWS = Object.values(VIEWS);
//# sourceMappingURL=capabilityStateView.js.map